var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1723 7.68959L15.4793 9.30473M8.99902 8.00077L4.33356 11.4999M17.5506 8.86612C18.0387 9.35427 18.0387 10.1457 17.5506 10.6339C17.0624 11.122 16.271 11.122 15.7828 10.6339C15.2947 10.1457 15.2947 9.35427 15.7828 8.86612C16.271 8.37796 17.0624 8.37796 17.5506 8.86612ZM4.21726 11.3661C4.70541 11.8543 4.70541 12.6457 4.21726 13.1339C3.7291 13.622 2.93765 13.622 2.44949 13.1339C1.96134 12.6457 1.96134 11.8543 2.44949 11.3661C2.93765 10.878 3.7291 10.878 4.21726 11.3661ZM10.8839 6.36612C11.3721 6.85427 11.3721 7.64573 10.8839 8.13388C10.3958 8.62204 9.60431 8.62204 9.11616 8.13388C8.628 7.64573 8.628 6.85427 9.11616 6.36612C9.60431 5.87796 10.3958 5.87796 10.8839 6.36612Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarLine);
export default __webpack_public_path__ + "static/media/bar-line.1a155625.svg";
export { ForwardRef as ReactComponent };